module.exports = __webpack_public_path__ + "img/tasks.19c0ac75.svg";